import { FC } from 'react';
import { IoRefresh } from 'react-icons/io5';

import { Anchor, Center, Loader } from '@mantine/core';

const InboxLoadMore: FC<{ hasMore: boolean; isLoadingMore: boolean; onLoadMore: () => void }> = ({
    hasMore,
    isLoadingMore,
    onLoadMore,
}) =>
    hasMore ? (
        <Center py="sm">
            <Anchor
                component="button"
                c="blue"
                fz="sm"
                fw={500}
                onClick={onLoadMore}
                disabled={isLoadingMore}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
            >
                {isLoadingMore ? <Loader size={12} color="blue" /> : <IoRefresh size={14} />}
                Load more
            </Anchor>
        </Center>
    ) : null;

export { InboxLoadMore };
